// extracted by mini-css-extract-plugin
export default {"main":"HorarioSelector_main__dWGJR"};